
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 20 20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M20 5.344h-7.703V10H20V5.344z","fill":"#21A365"}}),_c('path',{attrs:{"d":"M20 10h-7.703v4.656H20V10zM12.297 5.344H4.609V10h7.688V5.344z","fill":"#107C41"}}),_c('path',{attrs:{"d":"M12.297 14.656V10H4.625v8.391c0 .5.406.906.906.906h13.547c.5 0 .906-.406.906-.906v-3.735h-7.687z","fill":"#185B37"}}),_c('path',{attrs:{"d":"M19.078.703h-6.797V5.36H20V1.61a.93.93 0 00-.922-.906z","fill":"#33C481"}}),_c('path',{attrs:{"d":"M12.297.703h-6.75c-.5 0-.906.406-.906.906v3.735h7.671V.704h-.015z","fill":"#21A365"}}),_c('path',{attrs:{"d":"M9.297 15.078H1.016c-.547 0-1-.453-1-1V5.922c0-.547.453-1 1-1h8.28c.548 0 1 .453 1 1v8.156c0 .547-.437 1-1 1z","fill":"#17864C"}}),_c('path',{attrs:{"d":"M6.328 12.875l-.61-1.11c-.25-.437-.405-.734-.577-1.062h-.016c-.14.328-.281.625-.516 1.063l-.546 1.109H2.875l1.688-2.828-1.641-2.781h1.203l.61 1.156c.187.344.327.625.468.937h.031c.157-.343.266-.593.454-.937l.609-1.156h1.187L5.813 10l1.734 2.875H6.328z","fill":"#fff"}}),_c('path',{attrs:{"opacity":".2","d":"M10.422 5.828v8.25c0 .547-.453 1-1 1H4.75v.89h5.5c.547 0 1-.452 1-1V6.814a.968.968 0 00-.828-.985z","fill":"#000"}})])
          )
        }
      }
    